import {
  selectRosterDisplayName,
  selectTournamentDriverName,
} from "selectors/Roster";
import {
  MatchTeamContainer,
  PlayerNames,
  OrgLogoContainer,
  OrgName,
  TeamRecordContainer,
  TeamSelector,
} from "./styles";
import { Pick } from "model/Pickem/Pickem";
import { Match } from "model/Match/Match";
import { calculateTeamRecord } from "model/Match/Matches";
import { SelectableRosterOrgLogo } from "components/Logo/SelectableRosterOrgLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  rosterId: string;
  rosterDriverIds: string[];
  tournamentId: string;
  priorMatches: Match[];
  currentPick: Pick;
  updatePick: (teamId: string | undefined) => void;
}

export const MatchemMatchPickerTeam = ({
  rosterId,
  rosterDriverIds,
  tournamentId,
  priorMatches,
  currentPick,
  updatePick,
}: Props) => {
  const displayName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterId, tournamentId)
  );

  const teamDriverNames = useAppSelector((state) =>
    rosterDriverIds
      .map((id) => selectTournamentDriverName(state, id, tournamentId) ?? "???")
      .join(" | ")
  );

  const { wins, loses } = calculateTeamRecord(priorMatches, rosterId);

  return (
    <TeamSelector
      onClick={() => updatePick(rosterId)}
      selected={currentPick === rosterId}
    >
      <MatchTeamContainer>
        <OrgLogoContainer>
          <SelectableRosterOrgLogo
            rosterId={rosterId}
            tournamentId={tournamentId}
            selected={currentPick === rosterId}
          />
        </OrgLogoContainer>
        <OrgName>{displayName}</OrgName>
        <PlayerNames>{teamDriverNames}</PlayerNames>
        {priorMatches.length > 0 && (
          <TeamRecordContainer>
            ({wins} - {loses})
          </TeamRecordContainer>
        )}
      </MatchTeamContainer>
    </TeamSelector>
  );
};
